import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '../../../../../app/translate';
import { InventoryComponent } from '../../pages/inventory.component';
import { Subscription } from 'rxjs/Subscription';
import { LoadingService } from "../../../../shared/services/loading.service"//"../../../shared/services/loading.service";
import { Router } from '@angular/router';
import { InventoryService } from "../../inventory-service.service";
import { ModelCreateInspection, SystemComponentViewModel } from '../../inventory-models';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../../../../../app/modules/GET_NEW_UI/adapters/ordinal-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
export interface System {
  Id: number;
  SerialNumber: string;
  JobSiteId: number;
  systemId: number;
  componentList: SystemComponentViewModel[]
}


@Component({
  selector: 'app-wsre-create-new-inspection',
  templateUrl: './wsre-create-new-inspection.component.html',
  styleUrls: ['./wsre-create-new-inspection.component.scss'],
  providers: [InventoryService,
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }],

})
export class WsreCreateNewInspectionComponent implements OnInit {

  translateSubscription: Subscription;
  private _userLanguage = 'english';

  selected_chain: number;
  selected_jobSite: number;
  selected_date: Date = new Date();
  selected_jobNumber: string;
  selected_customerRef: string;
  selected_oldJobNo: string;
  selected_numOfLinks: number;
  systemList: System[];
  showErrorMessage: boolean = false;

  JobSiteId: number;
  isLoading = false;

  selected_idler: number;
  componentList: SystemComponentViewModel[] = []

  systemId: number;
  selected_chain_Id: number;
  selected_chain_Name: string;
  stringDate: string;

  constructor(
    private _translate: TranslateService,
    public dialogRef: MatDialogRef<InventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _loadingService: LoadingService,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private inventoryService: InventoryService,
    private _router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));

    console.log("data __", this.data)
    this.systemList = this.data.systemList;
    this.selected_chain = this.data.system != null && this.data.systemId == 1 ? this.data.system : null;
    this.selected_chain_Id = this.data.system != null && this.data.systemId == 1 ? this.data.system.SystemId : this.data.selected_chain_Id;

    this.systemId = this.data.systemId;
    this.JobSiteId = this.data.system != null ? this.data.system.JobSiteId : this.data.jobsites
    this.componentList = this.data.componentList

    if (this.componentList!=null && this.componentList.length == 1 ) {
      this.selected_idler = this.componentList[0].EqunitId
    }

    if (this.data.system == null) {
      this.JobSiteId = this.data.jobsites;
      this.selected_chain_Id = this.data.selected_chain_Id
      this.selected_chain_Name = this.data.selected_chain_Name
      this.systemId = 3;
    }

    if (this.data.systemId == 1) {
      this.systemId = 1

    } else if (this.data.systemId == 2) {
      this.systemId = 2
    }
    else if (this.data.systemId == 3) {
      this.selected_chain_Id = this.data.selected_chain_Id;
      this.JobSiteId = this.data.jobsites;
      this.systemId = 3;
    }


    console.log("info", this.systemId, this.selected_chain_Name, this.JobSiteId)

  }


  selectChain() {

    let findSelected = this.componentList.find(f => f.EqunitId == this.selected_chain)

    if (findSelected != null) {

      this.JobSiteId = this.data.system.JobSiteId
    }

  }

  selectIdler() {

    let findSelected = this.componentList.find(f => f.EqunitId == this.selected_idler)

    if (findSelected != null) {

      this.JobSiteId = this.data.system.JobSiteId
    }

  }

  onClickStartInspection() {
    console.log("JobSiteId", this.JobSiteId)
    console.log("selected_chain", this.selected_chain)
    console.log("selected_numOfLinks", this.selected_numOfLinks)
    console.log("selected_oldJobNo", this.selected_oldJobNo)
    console.log("selected_customerRef", this.selected_customerRef)
    console.log("selected_jobNumber", this.selected_jobNumber)
    console.log("selected_date", this.selected_date)
    console.log("selected_jobSite", this.selected_jobSite)

    let obj_ = new ModelCreateInspection()

    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.JobSiteId
    obj_["_systemId"] = this.data.system == null ? this.selected_chain_Id : this.data.system.SystemId //this.selected_chain
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["_numberOfLinks"] = this.selected_numOfLinks
    obj_["SystemTypeId"] = this.systemId == 3 ? 1 : this.systemId
    obj_["EqunitId"] = this.selected_idler;
    obj_["StringDate"] = this.datePipe.transform( this.selected_date, 'MM/dd/yyyy');

    this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService.WSRECreateNewInspection(obj_).subscribe(r => {
          console.log("r", r)

          if (r._status) {
            
            if (this.systemId == 3) this.systemId = 1;

            console.log("thisys_", this.systemId)
            this.showErrorMessage = false;
            this.onNoClick()
            this._router.navigate(['/repair-estimate', r._inspectionID, this.systemId]);
           
          } else {
            this.showErrorMessage = true;
          }

          this.finishedLoading();
        })



  }
  finishedLoading() {
    this._loadingService.finishedLoading();
    this.isLoading = false;
  }

  onNoClick() {
    this.dialogRef.close(true);
  }

  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  updateUserLang(lang: string) {
    this._userLanguage = lang;
    this.ref.detectChanges();
  }
}
